export default __webpack_public_path__ + "static/media/Roundcheck-white.9344caad.svg";